import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Row, Col, CardBody, Card, Container } from "reactstrap";
import { LoginRepository } from "../../repositories/login";
import logo from "../../assets/images/logo-mayca-circle-new.svg";
import wp from "../../assets/images/grupo-995.svg";
import "../../assets/scss/custom/pages/_login.scss";
import "./Login.scss";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import UserNotAssignedModal from "./UserNotAssignedModal";
import { userAuthActions } from "../../app/store/slices/user/slice";
import bg from "../../assets/images/login-bg.png";

const Login = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const notMember = useSelector((state) => state.userAuth.notMember);
  const dispatch = useDispatch();

  const handleOktaLogin = async () => {
    await oktaAuth.signInWithRedirect();
  };

  const handleCloseNotMemberModal = async () => {
    const logoutUser = async () => {
      try {
        const repo = new LoginRepository();
        repo.logoutOkta();
      } catch (logoutError) {
        console.error("Error durante el logout: ", logoutError);
      }
    };

    await logoutUser();
    dispatch(userAuthActions.setNotMember(false));
  };

  return (
    <Container>
      <UserNotAssignedModal
        isOpen={notMember}
        toggle={handleCloseNotMemberModal}
      />
      <Row className="pt-5">
        <Col lg={{ offset: 3, size: 6 }}>
          <Card className="shadow">
            <div
              className="text-white pt-5 pb-3 px-5"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${bg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px",
              }}
            >
              <Row className="h-100 align-items-center">
                <Col md="7" className="align-self-end">
                  <div className="">
                    <h3
                      style={{
                        font: 'normal normal 900 40px/21px "Avenir Regular"',
                        color: "#FFFFFF",
                      }}
                      className="mt-3"
                    >
                      ¡Bienvenido!
                    </h3>
                    <p
                      style={{
                        font: 'normal normal medium 20px/24px "Avenir Regular"',
                        letterSpacing: "-0.48px",
                        color: "#FFFFFF",
                      }}
                    >
                      Inicia sesión para acceder a tu plataforma
                      <br />
                      <strong
                        style={{
                          font: 'normal normal 20px/24px "Avenir Regular"',
                          letterSpacing: " -0.48px",
                          color: "#FFFFFF",
                        }}
                      >
                        Mayca One
                      </strong>
                    </p>
                  </div>
                </Col>
                <Col md={{ offset: 2, size: 3 }} className="align-self-center">
                  <div className="auth-logo-light">
                    <div className="avatar-md profile-user-wid">
                      <span className="avatar-title rounded-circle bg-light">
                        <img
                          src={logo}
                          alt=""
                          className="rounded-circle"
                          height="120"
                        />
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>

            <CardBody className="pt-0">
              <div className="mt-5 mb-3 d-grid ">
                <button
                  className="btn btn-block text-white login-button"
                  onClick={handleOktaLogin}
                >
                  Iniciar Sesión
                </button>
              </div>
              {/* <div className="mt-4 text-center">
                <Link to="/forgot-password" className="text-muted">
                  <i className="mdi mdi-lock me-1" />
                  ¿Olvid&oacute; su contraseña?
                </Link>
              </div> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
